import { DropdownMenu } from "@repo/ui/Dropdown/dropdownMenu";
import { IconDotsVertical } from "@tabler/icons-react";
import type { FC } from "react";
import { Button, MenuTrigger } from "react-aria-components";

interface AgentMoreMenuProps {
  onClickCopyPlaybookId: () => void;
  onClickDeleteAgent: () => void;
  isDisabled?: boolean;
}

export const AgentMoreMenu: FC<AgentMoreMenuProps> = ({
  onClickCopyPlaybookId,
  onClickDeleteAgent,
  isDisabled,
}) => {
  const menuItems = [
    { label: "Copy playbook ID", onClick: onClickCopyPlaybookId },
    { label: "Delete agent", onClick: onClickDeleteAgent },
  ];

  return (
    <div className="relative ml-3">
      <MenuTrigger>
        <Button
          className="relative flex items-center rounded-md bg-white p-1.5 text-foreground shadow-xs ring-1 ring-border-strong ring-inset hover:bg-gray-50 disabled:bg-slate-300 disabled:text-muted-foreground"
          isDisabled={isDisabled}
        >
          <span className="absolute -inset-1.5" />
          <span className="sr-only">Open agent menu</span>
          <IconDotsVertical className="h-6 w-6" />
        </Button>
        <DropdownMenu items={menuItems} />
      </MenuTrigger>
    </div>
  );
};
